import { STORAGE_KEYS } from "@/constants";

const isBrowser = () => typeof window !== "undefined";

export const getStoredAccessToken = () => {
  if (!isBrowser()) {
    return null;
  }

  return window.localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
};

export const setStoredAccessToken = (value: string | null) => {
  if (!isBrowser()) {
    return;
  }

  if (!value) {
    window.localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
    return;
  }

  window.localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, value);
};

export const getStoredRefreshToken = () => {
  if (!isBrowser()) {
    return null;
  }

  return window.localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN);
};

export const setStoredRefreshToken = (value: string | null) => {
  if (!isBrowser()) {
    return;
  }

  if (!value) {
    window.localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
    return;
  }

  window.localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, value);
};
